import { render, staticRenderFns } from "./integralrule.vue?vue&type=template&id=4706b0ae"
import script from "./integralrule.vue?vue&type=script&lang=js"
export * from "./integralrule.vue?vue&type=script&lang=js"
import style0 from "./integralrule.vue?vue&type=style&index=0&id=4706b0ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports